import { v1 as uuidv1 } from "uuid";
import axios from "axios";
import LogRecord from "../logRecord";
import { injectAxiosIntercptor } from "./util";

/**
 * @description: 上传日志
 * @return {*}
 */
export class LogUpload {
  static #_instance;
  static #_baseUrlMap = {
    UAT: "api.imagedt.com",
    PROD: "api.imagedt.com",
  };
  #_axios;
  id = Math.random();
  initOptions;
  /**
   * @description: 初始化 Monitor，如果已经存在实例，就直接返回实例，如果不存在，则实例化后返回
   * @param {*} options
   * @return {*}
   */
  static getInstance(options) {
    if (!LogUpload.#_instance) {
      LogUpload.#_instance = new LogUpload(options);
    }
    return LogUpload.#_instance;
  }

  constructor(options) {
    if (!LogUpload.#_instance) {
      this.id = Math.random();
      this.initOptions = options;
      if (!this.initOptions.enable) {
        console.warn("Moniter LogUpload is Disable!");
      }
      this.#_initAxios(options);
      this.#_initIntervalCollect(options);
    } else {
      console.warn("LogUpload 在导出时已经实例化，不需要再创建新实例");
      return LogUpload.#_instance;
    }
  }

  #_initAxios(options) {
    const { protocol, environment, projectCode } = options;
    const envHostName =
      LogUpload.#_baseUrlMap[environment] || LogUpload.#_baseUrlMap.UAT;

    this.#_axios = axios.create({
      withCredentials: false,
      baseURL: `${protocol}://${envHostName}/`,
      timeout: 1000 * 60 * 2,
      binary: false,
    });
    injectAxiosIntercptor(this.#_axios, projectCode);
  }

  /**
   * @description: 定时上传
   * @param {*} options
   * @return {*}
   */
  #_initIntervalCollect(options) {
    const { enable, collectTime } = options.intervalCollect;
    if (enable) {
      let timer = setInterval(async () => {
        try {
          await this.uploadAll();
        } catch (err) {
          clearInterval(timer);
          console.error("intervalUpload Error：", err);
        }
      }, collectTime * 1000);
    }
  }

  /**
   * @description: 日志上报
   * @param {*} logs
   * @return {*}
   */
  async #_webUploadApi(logs) {
    try {
      if (logs.length > 0) {
        await this.#_axios.post("/data-gatherer/event-log/web", { logs });
      }
    } catch (error) {
      console.error("_webUploadApi Error:", error.message);
    }
  }

  /**
   * @description: 上传全部日志
   * @param {boolean} clear 是否在上传完清空日志，默认为 true
   * @return {*}
   */
  async uploadAll({ clear } = { clear: true }) {
    if (!this.initOptions.enable) return;

    try {
      const db = LogRecord.getDiretcInstance();
      const logs = await db.getRecords();
      await this.#_webUploadApi(logs);
      if (clear) {
        const primaryKeys = logs.map((i) => i.id);
        await db.bulkDeleteRecord(primaryKeys);
      }
    } catch (error) {
      console.error("uploadAll Error:", error.message);
    }
  }

  /**
   * @description: 不记录，直接上传一条数据
   * @param {*} data
   * @return {*}
   */
  async directUploadOne(data) {
    if (!this.initOptions.enable) return;

    const eventTime = Date.now();
    const logs = [
      {
        ...data,
        eventTime,
        id: uuidv1(eventTime),
        localtion_origin: window.location.origin,
        location_path: window.location.href,
        screen: `w_${window.screen.width},h_${window.screen.height}`,
        window: `w_${window.innerWidth},h_${window.innerHeight}`,
      },
    ];
    await this.#_webUploadApi(logs);
  }
}
